// settings-import-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'sim.appr.unnamed': 'Uten navn',
  'sim.appr.document': 'Dokument',
  'sim.appr.historyLine': 'Historikklinje',
  'sim.appr.openingBalanceYear': 'Inngående balanse {year}',
  'sim.appr.debitCredit': 'Debet {debit} / Kredit {credit}',
  'sim.appr.voucherCount': '{count} bilag',
  'sim.appr.account': 'Konto',
  'sim.appr.inactive': 'inaktiv',
  'sim.appr.debitCreditLines': 'Debet {debit} / Kredit {credit} - {count} kontolinjer',
  'sim.appr.salesOutstanding': 'Salg {sales} · Utestående {outstanding}',
  'sim.appr.purchasesOutstanding': 'Kjøp {purchases} · Utestående {outstanding}',
  'sim.appr.noExtraDetails': 'Ingen ekstra detaljer',
  'sim.appr.statSales': 'salg {amount}',
  'sim.appr.statOutstanding': 'utest. {amount}',
  'sim.appr.statPurchases': 'kjøp {amount}',
  'sim.appr.openingBalanceLine': '{year}: {count} linjer - debet {debit} / kredit {credit}',
  'sim.appr.previewShown': 'viser {shown} av {total} {label}',
  'sim.appr.limitDocuments': 'Dokumentarkivet viser {shown} av {total} filer. Fullt arkiv ligger i original eksportpakke.',
  'sim.appr.limitLedger': 'Hovedbokarkivet viser {shown} av {total} historikklinjer. Full historikk ligger i original eksportpakke.',
  'sim.appr.importing': 'Importerer...',
  'sim.appr.approveImport': 'Godkjenn import',
  'sim.appr.warningsTitle': 'Varsler fra importanalysen',
  'sim.appr.willImport.title': 'Importeres når du godkjenner',
  'sim.appr.willImport.registers': 'Kunder, leverandører og produkter oppdateres i registrene.',
  'sim.appr.willImport.balances': 'Saldokontoer og inngående balanse legges inn per år.',
  'sim.appr.willImport.bankAccounts': 'Bankkontoer fra importerte kontonavn kobles til regnskapsoppsettet.',
  'sim.appr.history.title': 'Lagres som historikk/oppfølging',
  'sim.appr.history.sums': 'Kunde- og leverandørsummer vises i registrene.',
  'sim.appr.history.ledgerBalance': 'Utestående reskontrosaldo vises der SAF-T har saldo per part.',
  'sim.appr.history.openItems': 'Åpne poster, dokumentarkiv og hovedbokhistorikk lagres som importgrunnlag, ikke som bokførte bilag.',
  'sim.appr.notImported.title': 'Importeres ikke automatisk',
  'sim.appr.notImported.ledger': 'Historisk hovedbok bokføres ikke som live posteringer.',
  'sim.appr.notImported.documents': 'Importerte dokumenter blir ikke analysert eller bokført automatisk.',
  'sim.appr.updatesText': 'Dette oppdaterer kunder, leverandører, inngående balanse og bare kontoer som trengs for saldo. Historiske bilag og posteringer bokføres ikke automatisk.',
  'sim.appr.archiveDocsLabel': 'arkivdokumenter',
  'sim.appr.limitedPreview': 'Begrenset forhåndsvisning',
  'sim.appr.productCollision.title': 'Produktnummer finnes allerede',
  'sim.appr.productCollision.text': 'Plumme beholder eksisterende produkt som standard. Huk av hvis importproduktet også skal med; da får det et nytt varenummer med importnøkkel og kan slettes fra Produkter senere.',
  'sim.appr.importedProduct': 'Importert produkt',
  'sim.appr.existingProduct': 'eksisterende produkt',
  'sim.appr.sameKey': 'samme nøkkel',
  'sim.appr.importAsOwn': 'Importer "{name}" som eget produkt',
  'sim.appr.productExists': 'Produktnummer {number} finnes allerede som "{existing}". Ved godkjenning får importproduktet nytt varenummer, for eksempel IMP-{number}.',
  'sim.appr.invoiceCollision.title': 'Fakturanummer finnes allerede',
  'sim.appr.invoiceCollision.text': 'Regelverket krever at salgsdokumenter har en kontrollerbar, ubrutt nummerserie i systemet de ble utstedt fra. Disse fakturaene kommer fra et tidligere system, og lagres derfor som read-only importhistorikk i Plumme. De overskriver ikke nye Plumme-fakturaer og bokføres ikke på nytt som live fakturaer.',
  'sim.appr.invoiceLabel': 'Faktura {number}',
  'sim.appr.moreCount': '+ {count} til',
  'sim.appr.invoiceCollision.accept': 'Jeg forstår at disse fakturaene importeres som historikk, ikke som nye Plumme-fakturaer.',
  'sim.appr.panel.products': 'Produkter',
  'sim.appr.panel.productsEmpty': 'Ingen produkter foreslatt',
  'sim.appr.panel.customerStats': 'Kundestatistikk',
  'sim.appr.panel.customerStatsEmpty': 'Ingen kundestatistikk funnet',
  'sim.appr.panel.supplierStats': 'Leverandørstatistikk',
  'sim.appr.panel.supplierStatsEmpty': 'Ingen leverandørstatistikk funnet',
  'sim.appr.panel.openCustomerInvoices': 'Åpne kundefakturaer',
  'sim.appr.panel.openCustomerInvoicesEmpty': 'Ingen åpne kundefakturaer funnet',
  'sim.appr.panel.openSupplierInvoices': 'Åpne leverandørfakturaer',
  'sim.appr.panel.openSupplierInvoicesEmpty': 'Ingen åpne leverandørfakturaer funnet',
  'sim.appr.panel.openingBalances': 'Inngående balanse',
  'sim.appr.panel.openingBalancesEmpty': 'Ingen inngående balanser funnet',
  'sim.appr.panel.documents': 'Dokumentarkiv',
  'sim.appr.panel.documentsEmpty': 'Ingen arkivdokumenter funnet',
  'sim.appr.panel.ledger': 'Hovedbokarkiv',
  'sim.appr.panel.ledgerEmpty': 'Ingen historikklinjer funnet',
  'sim.appr.bankReadyOne': '{count} konto er klare',
  'sim.appr.bankReadyMany': '{count} kontoer er klare',
  'sim.appr.bankMissing': '{missing} av {total} mangler avstemmingsdato',
  'sim.appr.bankDone': 'Startsaldo og avstemt til og med er satt.',
  'sim.appr.bankTodo': 'Sett startsaldo og «avstemt til og med» før importen kan godkjennes.',
  'sim.appr.panel.accounts': 'Kontoer',
  'sim.appr.panel.accountsEmpty': 'Ingen saldokontoer foreslått',
  'sim.appr.panel.customers': 'Kunder',
  'sim.appr.panel.customersEmpty': 'Ingen kunder foreslått',
  'sim.appr.panel.suppliers': 'Leverandører',
  'sim.appr.panel.suppliersEmpty': 'Ingen leverandører foreslått',
  'sim.appr.afterText': 'Du kan avbryte her, sjekke siste analyse i siden bak og åpne godkjenningen igjen. Kontroller inngående balanse før du bruker tallene videre.',
  'sim.appr.bank.title': 'Bankkontoer fra importen',
  'sim.appr.bank.whereTitle': 'Hvor overtar Plumme?',
  'sim.appr.bank.whereText': '«Avstemt til og med» er datoen banken sist ble avstemt i det gamle systemet. Plumme regner alt før den datoen som gjort opp der, og begynner å kreve bankutskrifter først dagen etter. Startsaldoen er saldoen ved utgangen av akkurat denne datoen – ikke dagens eller importfilens nyeste saldo.',
  'sim.appr.bank.kindTax': 'Skattetrekk',
  'sim.appr.bank.kindOperating': 'Drift',
  'sim.appr.bank.ready': 'Klar',
  'sim.appr.bank.confirmBalance': 'Jeg har kontrollert datoen og saldoen mot banken.',
  'sim.appr.bank.reviewRequired': 'Må kontrolleres',
  'err.import.bankReviewRequired': 'Kontroller og bekreft avstemmingsdato og saldo for hver importerte bankkonto.',
  'sim.appr.bank.missingDate': 'Mangler dato',
  'sim.appr.bank.lastReconciled': 'Sist avstemt i gammelt system',
  'sim.appr.bank.balanceAtDate': 'Saldo ved utgangen av denne datoen',
  'sim.appr.detail.search': 'Søk i {label}',
  'sim.appr.detail.shown': '{shown} av {total} vises',
  'sim.imp.intro': 'Last opp en komplett eksportpakke, eller velg flere filer samtidig: SAF-T, CSV og Excel. Plumme analyserer innholdet først, og du godkjenner hva som faktisk importeres.',
  'sim.imp.elapsedMinSec': '{min} min {sec} sek',
  'sim.imp.elapsedSec': '{sec} sek',
  'sim.imp.step.uploading': 'Laster opp eksportpakken',
  'sim.imp.step.analyzing': 'Analyserer SAF-T, Excel og bilagsmapper',
  'sim.imp.step.ready': 'Klar for godkjenning av grunnlagsdata',
  'sim.imp.step.committed': 'Grunnlagsdata er importert',
  'sim.imp.title.error': 'Importen stoppet',
  'sim.imp.title.committed': 'Grunnlagsimport fullført',
  'sim.imp.title.analyzed': 'Importanalyse ferdig',
  'sim.imp.title.running': 'Importerer komplett regnskap',
  'sim.imp.exportPackage': 'Eksportpakke',
  'sim.imp.elapsed': 'pågått {time}',
  'sim.imp.uploadedOf': '{sent} av {total} lastet opp.',
  'sim.imp.analyzingHelp': 'Store eksportpakker og filsett kan bruke flere minutter. Hold fanen åpen mens Plumme finner SAF-T, CSV, Excel-filer og bilagsmapper.',
  'sim.imp.committingHelp': 'Plumme oppdaterer kontoplan, kunder, leverandører og inngående balanse. Ikke trykk flere ganger.',
  'sim.imp.analyzeFailed': 'Kunne ikke analysere eksportpakken.',
  'sim.imp.foundFiles': 'Fant {count} filer',
  'sim.imp.foundBreakdown': '{saft} SAF-T, {excel} Excel, {csv} CSV og {vouchers} bilagsfiler.',
  'sim.imp.dontClose': 'Ikke lukk fanen mens importen jobber. Du kan fortsette når analysen er ferdig og grunnlagsdataene vises for godkjenning.',
  'sim.set.notConnected': '{label} er ikke koblet i Plumme ennå.',
});
